import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsProvider } from "../../common/providers/utils-provider.service";

@Injectable(
    { providedIn: 'root' }
)
export class BreadcrumbProvider {
    private _currentCrumbs: Crumb[] = [];
    public get currentCrumbs() {
        return this._currentCrumbs;
    }
    public get lastCrumb() {
        return this._currentCrumbs.length ? this._currentCrumbs[this.currentCrumbs.length - 1] : null;
    }

    private _history: Crumb[][] = [];
    constructor(
        private utils: UtilsProvider,
        private router: Router
    ) { }

    public reset() {
        this._history = [];
        this._currentCrumbs = [];
    }

    public append(crumb: Crumb): void {
        this._history.push(this._currentCrumbs);
        this._currentCrumbs = this._currentCrumbs.slice();
        this._currentCrumbs.push(crumb);
    }

    public setCrumbs(crumbs: Crumb[]): void {
        this._history.push(this._currentCrumbs);
        this._currentCrumbs = crumbs;
    }

    public setDefaultCrumbs(defaultCrumbs: Crumb[]): boolean {
        if (!this.lastCrumb || this.lastCrumb.url !== this.router.url) {
            this.setCrumbs(defaultCrumbs);
            return true;
        }

        return false;
    }

    public onCrumbClicked(crumb: Crumb): void {
        // this._history.push(this._currentCrumbs);
        // this._currentCrumbs = this._currentCrumbs.slice(0, this._currentCrumbs.indexOf(crumb) + 1);
        this.router.navigateByUrl(crumb.url ?? '/');
    }

    public onBackClicked(): void {
    }
}

export interface Crumb {
    title: string;
    shortTitle: string;
    url?: string;
}
